<template>
  <v-container>
    <v-row>
      <v-col>
        <v-text-field v-model="view_record.search_value" label="Search ..." append-icon="fas fa-search" outlined style="margin: 0 0 -30px 0;"></v-text-field>
      </v-col>
      <v-col md="12">
        <v-card elevation="4">
          <v-card-title>
            View Exist Report
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-data-table :headers="view_record.report_header" :items="report_items" :items-per-page="5" class="elevation-1">
              <template v-slot:item.download="{ item }">
                <a :href="'http://www.genetech.group/static/' + item.report_name + '.pdf'" :download="item.report_name + '.pdf'">
                  <v-icon small>{{item.download}}</v-icon>
                </a>
              </template>
              <template v-slot:item.delete="{ item }">
                <v-icon small @click="$store.commit('setDeleteDialogStatus', true); $store.commit('setDeleteDialogItem', item)">{{item.delete}}</v-icon>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: 'view_reports',
  data: () => ({
    view_record: {}
  }),
  created () {
    this.asyn_data()
    this.view_record = this.$store.state.viewRecord
    this.view_record.asyn_data = this.asyn_data
  },
  computed: {
    report_items () {
      return this.view_record.report_items.filter(item =>
        item.essential_id.includes(this.view_record.search_value) ||
        item.open_id.includes(this.view_record.search_value) ||
        item.client_id.includes(this.view_record.search_value) ||
        item.report_name.includes(this.view_record.search_value) ||
        item.SalesGTLCode.includes(this.view_record.search_value) ||
        item.download.includes(this.view_record.search_value) ||
        this.view_record.search_value === ''
      )
    }
  },
  methods: {
    asyn_data () {
      this.$apis.readEssential().then(res => {
        let result = []
        res.data.data.forEach(item => {
          item.download = 'far fa-file-pdf'
          item.delete = 'far fa-trash-alt'
          result.push(item)
        })
        this.$store.commit('setReportItem', result)
      })
    }
  }
}
</script>
